<i [class]="$iconClass()" [style.fontSize.px]="$size()"></i>
